import { useEffect } from "react";
import { useSidebarNavContext } from "@stores/SidebarNavContext";
/**
 * Tells the sidebar which community the current page belongs to. Only pages the URL cannot
 * answer for need it: Report Settings is addressed by a report or a template id, so without
 * this the sidebar has no way to know which community to keep open and highlighted.
 *
 * Cleared on unmount, so a page that publishes nothing leaves no stale selection behind.
 */
export const useActiveCommunity = (communityId) => {
    const { setActiveCommunityId } = useSidebarNavContext();
    useEffect(() => {
        setActiveCommunityId(communityId);
        return () => setActiveCommunityId(undefined);
    }, [communityId, setActiveCommunityId]);
};
export default useActiveCommunity;
